import { IsiIWSScreen } from "./Isilog/Core/IsiIwsUICore";
import { IIsiDtoIwsUIScreen } from "./Dtos/Isilog.IsiComponent.IsiDataTransferObject";

export function getScreen(screen: IIsiDtoIwsUIScreen): Promise<IsiIWSScreen> {
    //switch (screenName) {
    //case "PARC001":
    return new Promise((resolve: (screen: IsiIWSScreen) => void, reject): void => {
        let screenName = uiCore.getOptions().screen.father;
        if (!screenName) {
            screenName = screen.name;
        }
        import(
            /* webpackChunkName: "Business/[request]" */
            `./Business/${screen.typeScript}`).then((module) => {
                resolve(new module[screenName]());
            }).catch((e) => {
                console.log(e);
            });
    });

    //break;
    //} 
}

//export class PARC001Loader {
//    constructor() {
//        //let screen = new PARC001();
//        let screen = 
//    }
//}